import { PageTitle } from '@goparrot-dashboard/shared-ui';
import * as React from 'react';
import { useI18n } from '@goparrot-dashboard/i18n';
import { LoginForm } from '../forms/LoginForm';
import { useSsoLoginCallbackMutation } from '../hooks/useSsoLoginCallbackMutation';
import { useLoginWithHandlers } from './hooks/useLoginWithHandlers';
import { ErrorBanner } from './ErrorBanner';

export const LoginPage: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { getIntlString } = useI18n();

  const { login, errorMsg } = useLoginWithHandlers();
  const { errorMsg: ssoErrorMsg } = useSsoLoginCallbackMutation();
  const errorMessage = errorMsg || ssoErrorMsg;

  return (
    <article className="tw-text-base">
      <header>
        <PageTitle hasMargin={false} fontWeight="medium" seoTitle={getIntlString('title.signIn')}>
          {getIntlString('title.signIn')}
        </PageTitle>
      </header>
      {errorMessage ? <ErrorBanner msg={errorMessage} /> : null}
      <section className="tw-mt-4">
        <LoginForm onSubmit={(data) => login.mutate({ data })} isFormLoading={login.isLoading || !!login.data} />
      </section>
    </article>
  );
};
